import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

/* ── Número WhatsApp Heritage (trocar quando disponível) ── */
const WA_NUMERO = '31972541567';

const waLink = (numero, msg) =>
  `https://wa.me/55${numero}?text=${encodeURIComponent(msg)}`;

const AD_SLIDES = [
  {
    id: 'sealant',
    tipo: 'produto',
    label: 'Produto Heritage',
    titulo: 'Heritage Sealant',
    subtitulo: 'Proteção que preserva. Beleza que atravessa o tempo.',
    descricao: 'Selante premium para carros antigos e de coleção. Protege contra chuva, sol e poluição, realçando o brilho original do seu clássico.',
    cta: 'Conhecer produto',
    href: '/produtos',
    externo: false,
    video: '/assets/heritage_banner_animado.mp4',
    imagem: null,
    tema: 'sealant',
    icones: [
      { icon: '🛡', label: 'Proteção' },
      { icon: '✶', label: 'Brilho' },
      { icon: '💧', label: 'Hidro' },
      { icon: '🚗', label: 'Clássicos' },
    ],
  },
  {
    id: 'consorcio',
    tipo: 'consorcio',
    label: 'Consórcio',
    titulo: 'Consórcio Heritage',
    subtitulo: 'Realize o sonho do seu clássico com planejamento.',
    descricao: 'Planos criados para quem quer adquirir um veículo antigo de forma organizada, sem juros e com parcelas que cabem no orçamento.',
    cta: 'Ver planos',
    href: waLink(WA_NUMERO, 'Olá! Vi o Consórcio Heritage e gostaria de saber mais sobre os planos para adquirir um veículo clássico. Podem me enviar mais informações?'),
    externo: true,
    video: null,
    imagem: null,
    tema: 'consorcio',
    icones: [
      { icon: '📋', label: 'Sem juros' },
      { icon: '🏆', label: 'Curadoria' },
      { icon: '🤝', label: 'Parceria' },
      { icon: '💰', label: 'Planejamento' },
    ],
  },
  {
    id: 'seguro',
    tipo: 'seguro',
    label: 'Seguro',
    titulo: 'Seguro para Clássicos',
    subtitulo: 'Proteção especializada para veículos que têm história.',
    descricao: 'Cobertura com avaliação por valor acordado e assistência 24h. Porque seu clássico merece um cuidado diferenciado.',
    cta: 'Solicitar cotação',
    href: waLink(WA_NUMERO, 'Olá! Gostaria de solicitar uma cotação de seguro para veículo clássico com a Heritage. Podem me ajudar?'),
    externo: true,
    video: null,
    imagem: null,
    tema: 'seguro',
    icones: [
      { icon: '🛡', label: 'Cobertura' },
      { icon: '🕐', label: 'Assistência 24h' },
      { icon: '📄', label: 'Valor acordado' },
      { icon: '⭐', label: 'Especializado' },
    ],
  },
];

/* Renderiza Link interno ou âncora externa conforme o slide */
const SlideLink = ({ slide, className, children }) =>
  slide.externo
    ? <a href={slide.href} target="_blank" rel="noopener noreferrer" className={className}>{children}</a>
    : <Link to={slide.href} className={className}>{children}</Link>;

/* ─── Carrossel completo (Landing Page) ────────────────────────────────── */
export function BannerCarouselFull() {
  const [atual, setAtual] = useState(0);
  const [animando, setAnimando] = useState(false);
  const timerRef = useRef(null);

  const irPara = (idx) => {
    if (animando || idx === atual) return;
    setAnimando(true);
    setTimeout(() => { setAtual(idx); setAnimando(false); }, 320);
  };

  const anterior = () => irPara((atual - 1 + AD_SLIDES.length) % AD_SLIDES.length);
  const proximo  = () => irPara((atual + 1) % AD_SLIDES.length);

  useEffect(() => {
    timerRef.current = setInterval(() => setAtual(prev => (prev + 1) % AD_SLIDES.length), 6000);
    return () => clearInterval(timerRef.current);
  }, []);

  const slide = AD_SLIDES[atual];

  return (
    <div className="ad-carousel">
      <div className={`ad-slide ad-slide-${slide.tema} ${animando ? 'ad-slide-out' : 'ad-slide-in'}`}>
        {slide.video && (
          <video className="ad-slide-bg-img" src={slide.video} autoPlay muted loop playsInline />
        )}
        {!slide.video && slide.imagem && (
          <img src={slide.imagem} alt={slide.titulo} className="ad-slide-bg-img" onError={e => { e.target.style.display = 'none'; }} />
        )}
        <div className="container ad-slide-inner">
          <div className="ad-slide-copy">
            <span className="ad-label">{slide.label}</span>
            <h2 className="ad-titulo">{slide.titulo}</h2>
            <p className="ad-subtitulo">{slide.subtitulo}</p>
            <p className="ad-descricao">{slide.descricao}</p>
            <div className="ad-icones">
              {slide.icones.map(ic => (
                <div className="ad-icone" key={ic.label}>
                  <span>{ic.icon}</span>
                  <small>{ic.label}</small>
                </div>
              ))}
            </div>
            <SlideLink slide={slide} className="ad-cta">{slide.cta} &rarr;</SlideLink>
          </div>
        </div>
      </div>
      <button className="ad-nav ad-nav-prev" onClick={anterior} aria-label="Anterior">&#8592;</button>
      <button className="ad-nav ad-nav-next" onClick={proximo}  aria-label="Proximo">&#8594;</button>
      <div className="ad-dots">
        {AD_SLIDES.map((s, i) => (
          <button key={s.id} className={`ad-dot ${i === atual ? 'ad-dot-active' : ''}`} onClick={() => irPara(i)} aria-label={`Ir para ${s.titulo}`} />
        ))}
      </div>
    </div>
  );
}

/* ─── Carrossel slim (página de detalhe do veículo) ────────────────────── */
export function BannerCarouselSlim() {
  const [atual, setAtual] = useState(0);
  const [animando, setAnimando] = useState(false);
  const timerRef = useRef(null);

  const irPara = (idx) => {
    if (animando || idx === atual) return;
    setAnimando(true);
    setTimeout(() => { setAtual(idx); setAnimando(false); }, 280);
  };

  const anterior = () => irPara((atual - 1 + AD_SLIDES.length) % AD_SLIDES.length);
  const proximo  = () => irPara((atual + 1) % AD_SLIDES.length);

  useEffect(() => {
    timerRef.current = setInterval(() => setAtual(prev => (prev + 1) % AD_SLIDES.length), 5000);
    return () => clearInterval(timerRef.current);
  }, []);

  const slide = AD_SLIDES[atual];

  return (
    <div className="ad-slim-carousel">
      <div className={`ad-slim-slide ad-slide-${slide.tema} ${animando ? 'ad-slim-out' : 'ad-slim-in'}`}>
        {slide.video && (
          <video className="ad-slide-bg-img" src={slide.video} autoPlay muted loop playsInline />
        )}
        {!slide.video && slide.imagem && (
          <img src={slide.imagem} alt={slide.titulo} className="ad-slide-bg-img" onError={e => { e.target.style.display = 'none'; }} />
        )}

        <div className="ad-slim-inner">
          <div className="ad-slim-icon">{slide.icones[0].icon}</div>

          <div className="ad-slim-copy">
            <span className="ad-slim-label">{slide.label}</span>
            <strong className="ad-slim-titulo">{slide.titulo}</strong>
            <span className="ad-slim-sub">{slide.subtitulo}</span>
          </div>

          <SlideLink slide={slide} className="ad-slim-cta">{slide.cta} →</SlideLink>
        </div>
      </div>

      <button className="ad-slim-nav ad-slim-prev" onClick={anterior} aria-label="Anterior">‹</button>
      <button className="ad-slim-nav ad-slim-next" onClick={proximo}  aria-label="Proximo">›</button>

      <div className="ad-slim-dots">
        {AD_SLIDES.map((s, i) => (
          <button key={s.id} className={`ad-slim-dot ${i === atual ? 'ad-slim-dot-active' : ''}`} onClick={() => irPara(i)} />
        ))}
      </div>
    </div>
  );
}

export default BannerCarouselFull;
